// src/pages/context/GamesContext.jsx
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const GamesContext = createContext({
  gamesData: null,
  loading: false,
});

const GamesProvider = ({ children }) => {
  const [gamesData, setGamesData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchupdateGames = async () => {
      try {
        setLoading(true);

        const body = {
          env: "testing",
        };

        // console.log("Request Body:", body);

        const res = await axios.post(
          "",
          body,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // console.log("API Response:", res.data);

        if (res.data?.data && Array.isArray(res.data.data)) {
          const mappedGames = res.data.data.map((game) => {
            let combinedRules = [];

            try {
              // Parse rules (images) and rules_content (texts)
              const parsedRules = game.rules && game.rules !== ""
                ? JSON.parse(game.rules)
                : null;

              const parsedRulesContent = game.rules_content && game.rules_content !== ""
                ? JSON.parse(game.rules_content)
                : null;

              // ---- NORMALISE rules (image URLs) ----
              let rulesObj = {};
              if (Array.isArray(parsedRules)) {
                // Handle both:
                // 1) [{ "1": "img1", "2": "img2" }]
                // 2) [{ "1": "img1" }, { "2": "img2" }, ...]
                parsedRules.forEach((obj) => {
                  if (obj && typeof obj === "object") {
                    Object.assign(rulesObj, obj);
                  }
                });
              } else if (parsedRules && typeof parsedRules === "object") {
                rulesObj = parsedRules;
              }

              // ---- NORMALISE rules_content (texts) ----
              let contentObj = {};
              if (Array.isArray(parsedRulesContent)) {
                // Same: merge all objects into one
                parsedRulesContent.forEach((obj) => {
                  if (obj && typeof obj === "object") {
                    Object.assign(contentObj, obj);
                  }
                });
              } else if (parsedRulesContent && typeof parsedRulesContent === "object") {
                contentObj = parsedRulesContent;
              }

              // Now rulesObj: { "1": "img1", "2": "img2", ... }
              // and contentObj: { "1": "text1", "2": "text2", ... }

              const ruleKeys = Object.keys(rulesObj).sort(
                (a, b) => Number(a) - Number(b)
              );

              combinedRules = ruleKeys.map((key) => ({
                id: key,
                image: rulesObj[key] || "",
                content: contentObj[key] || "",
              }));

              // console.log("Combined rules for", game.name, ":", combinedRules);
            } catch (e) {
              console.error("Error parsing rules for", game.name, ":", e);
            }

            return {
              gamename: game.name,
              titlename: game.title_name || game.name,
              game_type: game.game_type,
              game_type_name: game.game_type_name,
              image: game.image,
              popular: game.popular,
              description: game.description,
              status: game.status,
              id: game.id,
              banner_video: game.banner_video,
              rules: combinedRules,
              gameinfo: game.description,
              status: game.status,
              landscape: game.landscape,
            };
          });

          setGamesData({
            ...res.data,
            data: mappedGames,
          });
        } else {
          setGamesData(res.data);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchupdateGames();
  }, []);

  return (
    <GamesContext.Provider value={{ gamesData, loading }}>
      {children}
    </GamesContext.Provider>
  );
};

export default GamesProvider;
